import strapi, { mapStrapiData } from '../lib/strapi';
import qs from 'qs';

export const getBuyerPageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_image: true,
        marketplace_image: true,
        feature_highlights: { populate: '*' }
      }
    });

    const response = await strapi.get(`/for-buyers-page?${query}`);
    return mapStrapiData(response);
  } catch (error) {
    console.error('Error fetching For Buyers Page data:', error);
    return null;
  }
};